function Protected() {
  return <h2>Protected</h2>;
}

export default Protected;